import React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import {TARMAC} from '../../../shared/style/colors';
import {Title, ComponentContainer} from './shared/styles';
import NavAnchor, {NAV_ANCHOR_OFFSET} from '../../tool-profile/components/shared/nav-anchor';
import {BASE_TEXT} from '../../../shared/style/typography';
import {PHONE} from '../../../shared/style/breakpoints';
import withErrorBoundary from '../../../shared/enhancers/error-boundary';

const UnorderedList = glamorous.ul({
  margin: '20px 0',
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  padding: '0 0 0 20px'
});

const LineItem = glamorous.li({
  margin: '10px 0',
  flexBasis: '48%',
  [PHONE]: {
    flexBasis: '100%'
  },
  color: TARMAC,
  ...BASE_TEXT
});

const Features = ({tool}) => {
  const features = tool.features
    .replace(/(\r\n|\n|\r)/gm, '')
    .split(';')
    .filter(feature => feature && feature !== '↵' && feature !== ' ');
  return (
    <ComponentContainer>
      <NavAnchor id="features" offset={NAV_ANCHOR_OFFSET} />
      <Title>{tool.name}&#39;s Features</Title>
      <UnorderedList>
        {features.map((feature, index) => (
          <LineItem key={index}>{feature}</LineItem>
        ))}
      </UnorderedList>
    </ComponentContainer>
  );
};

Features.propTypes = {
  tool: PropTypes.object
};

export default withErrorBoundary(true)(Features);
